/**
 * An issue as a prompt for a coding agent — "Copy as prompt" in the issue
 * drawer. Built from /issues-v6/:id/agent (the MCP read), so what is pasted is
 * what the agent would read over MCP: the issue, what kind of fix, and each
 * failure with its step and error text.
 */

import { CATEGORY } from 'features/issues/components/IssueTags';

const MAX_EVIDENCE = 20;

export function issuePrompt(view) {
  const lines = [
    `Fix this issue in the "${view.agent}" agent (Trodo issue #${view.id}${view.version > 1 ? `, version ${view.version}` : ''}).`,
    '',
    `# ${view.title}`,
    view.category && CATEGORY[view.category] ? `Kind of fix: ${CATEGORY[view.category].label} — ${CATEGORY[view.category].hint}.` : null,
    `Seen ${view.evidence_count} time(s), last ${view.last_seen_at ? new Date(view.last_seen_at).toISOString() : 'unknown'}.`,
    '',
    '## Root cause',
    view.root_cause,
  ];
  if (view.solution) lines.push('', '## Suggested change', view.solution);
  const ev = (view.evidence || []).slice(0, MAX_EVIDENCE);
  if (ev.length) {
    lines.push('', `## Evidence${view.evidence_count > ev.length ? ` (${ev.length} of ${view.evidence_count}, newest first)` : ''}`);
    for (const e of ev) {
      const where = [e.kind, e.id, e.kind === 'span' && e.run_id ? `in run ${e.run_id}` : null, e.step ? `step ${e.step}` : null]
        .filter(Boolean).join(' ');
      const what = [e.error_type, e.excerpt].filter(Boolean).join(': ');
      lines.push(`- ${where}${what ? ` — ${what.replace(/\s+/g, ' ').slice(0, 300)}` : ''}`);
    }
  }
  lines.push(
    '',
    'The root cause is a lead: confirm it against the evidence before changing code.',
    `With the Trodo MCP, get_issue_failures (issue_id ${view.id}) returns each failure's inputs to replay it.`,
  );
  return lines.filter((l) => l !== null).join('\n');
}
